<template>
  <div class="services">
    <div class="container">
      <div class="title">
        <p>我们的服务</p>
        <span>Our services</span>
        <i></i>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="img">
            <router-link
              :to="{
                path: $Router.serviceslist.path,
                query: { cateid: item.cate_id },
              }"
              ><img :src="item.cover_img" alt="" />
            </router-link>
          </div>
          <div class="text">
            <h2>{{ item.cate_name }}</h2>
            <div class="info">
              {{ item.description }}
            </div>
            <ul class="subnav">
              <li v-for="(item1, index) in item.noSpecial" :key="index">
                <router-link
                  :to="{
                    path: $Router.servicescontent.path,
                    query: {
                      id: item1.id,
                    },
                  }"
                >
                  {{ item1.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from './services'

export default {
  name: 'services',
  data () {
    return {
      cate_id: 3,
      columnLimit: 20,
      columnPage: 1,
      limit: 4,
      total: 0,
      page: 1,
      list: []
    }
  },
  created () {
    service.getArtivleListByColumnId(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./services";
</style>



// WEBPACK FOOTER //
// src/components/index/services/services.vue